import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {ActivityInterface} from '../../../../class/api/Activity';
import {HydraService} from '../../../../core/services/hydra.service';
import {ActivityComment, ActivityCommentInterface} from '../../../../class/api/ActivityComment';
import { FormsModule } from '@angular/forms';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-log-comment-box',
    templateUrl: './log-comment-box.component.html',
    styleUrls: ['./log-comment-box.component.scss'],
    imports: [FormsModule, MatButton]
})
export class LogCommentBoxComponent implements OnInit {
    private hydraService = inject(HydraService);


    @Input() public activity: ActivityInterface;

    private _comment: ActivityCommentInterface;
    @Input() set comment(comment: ActivityCommentInterface){
        this._comment = comment;
        this.commentaire = comment?.commentaire ?? '';
        this.editMode = true;
    }

    @Output() commentPosted: EventEmitter<ActivityCommentInterface> = new EventEmitter<
        ActivityCommentInterface
        >();

    public commentaire = '';
    public editMode = false;

    public isBusy = false;


    public postComment(): void {
        const data = new ActivityComment();
        data.activity = this.activity['@id'];
        data.commentaire = this.commentaire;

        if(this._comment){
            data.id = this._comment.id;
            data['@id'] = this._comment['@id'];
        }

        this.hydraService.save('/api/activity_comments', data).subscribe(
            (res: ActivityCommentInterface) => {
                this.commentPosted.emit(res);

                if(this._comment){
                    this._comment.commentaire = res.commentaire;
                    this._comment.dateModification = res.dateModification;
                }
                this.commentaire = '';
                this.isBusy = false;
            },
            () => {
                this.isBusy = false;
            }
        );
    }

    public cancel(): void
    {
        this.commentPosted.emit(this._comment);
    }

    ngOnInit(): void {
    }

}
